import React from "react";

import { css, cx } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { FontSizes } from "@/assets/fonts.ts";
import { Icons } from "@/assets/icons.ts";
import { useStyles } from "@/hooks/useStyles.ts";
import { ContactMode, ContactPatient } from "@/pages/patient-medical-file/contact-patient/ContactPatient.tsx";
import { Button } from "@/uiKit/atoms/Button.tsx";
import { Card } from "@/uiKit/atoms/Card.tsx";
import { CardContent } from "@/uiKit/atoms/CardContent.tsx";
import { CardFooter } from "@/uiKit/atoms/CardFooter.tsx";
import { CardHeader } from "@/uiKit/atoms/CardHeader.tsx";

type EntourageProps = {
  patientId: string;
};

export const Entourage: React.FC<EntourageProps> = ({ patientId }) => {
  const { t } = useTranslation();
  const styles = useStyles(makeStyles);

  const [mode, setMode] = React.useState<ContactMode>({ mode: "view" });

  return (
    <Card>
      <CardHeader title={t("contact.entourage")} />
      <CardContent>
        <ContactPatient patientId={patientId} mode={mode} setMode={setMode} />
      </CardContent>
      <CardFooter className={styles.footer}>
        <Button
          id="add-relationship"
          data-action="medical-file.entourage.add"
          startIcon={<Icons.filePlus className={styles.icon} />}
          variant="contained"
          disabled={mode.mode !== "view"}
          className={cx({
            [styles.editMode]: mode.mode !== "view",
          })}
          onClick={() => setMode({ mode: "create" })}
        >
          {t("contact.addRelationship")}
        </Button>
      </CardFooter>
    </Card>
  );
};

const makeStyles = () => ({
  editMode: css({
    display: "none",
  }),
  footer: css({
    justifyContent: "flex-start",
  }),
  icon: css({
    width: FontSizes.body,
    height: FontSizes.body,
  }),
});
